import { Injectable, OnDestroy, signal } from '@angular/core';

export const INLINE_TOAST_DEFAULT_DURATION_MS = 3000;

export interface InlineToastMessage {
    key: string;
    params?: Record<string, unknown>;
}

@Injectable()
export class InlineToastService implements OnDestroy
{
    public readonly message = signal<InlineToastMessage | null>(null);

    private hideTimeout: ReturnType<typeof setTimeout> | null = null;

    public show(key: string, params?: Record<string, unknown>, durationMs = INLINE_TOAST_DEFAULT_DURATION_MS
    ): void
    {
        this.clearTimeout();
        this.message.set({ key, params });
        this.hideTimeout = setTimeout(() => this.hide(), durationMs);
    }

    public hide(): void
    {
        this.clearTimeout();
        this.message.set(null);
    }

    public ngOnDestroy(): void
    {
        this.clearTimeout();
    }

    private clearTimeout(): void
    {
        if (this.hideTimeout)
        {
            clearTimeout(this.hideTimeout);
            this.hideTimeout = null;
        }
    }
    
}